import { adminList, adminDashboard } from "constants/admin";
import * as api from "../API/index";
import { authorizedUser } from "components/CommonComponents/CommonFunctions";

export const addAdmin = async (bodyData) => {
  try {
    const res = await api.add_admin(bodyData);
    return res?.data;
  } catch (error) {
    authorizedUser(error?.response?.data);
    return error?.response?.data || error;
  }
};

export const getAdminList = async (dispatch, pageNum, filters) => {
  try {
    const res = await api.get_admin_list(pageNum, filters);
    dispatch({ type: adminList, payload: res?.data });
  } catch (error) {
    dispatch({
      type: adminList,
      payload: error?.response?.data || error,
    });
    authorizedUser(error?.response?.data);
  }
};

export const getAdminById = async (id) => {
  try {
    const res = await api.get_admin_by_id(id);
    return res?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

export const updateAdminById = async (id, bodyData) => {
  try {
    const res = await api.update_admin_by_id(id, bodyData);
    return res?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};
//pofile view
export const getAdminProfileDetails = async () => {
  try {
    const res = await api.get_admin_profile_details();
    return res?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

// profile upate
export const updateAdminProfileDetails = async (bodyData) => {
  try {
    const res = await api.update_admin_profile_details(bodyData);
    return res?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

//admin dashboard
export const getAdminDashboard = async (dispatch, pageNum = 1) => {
  try {
    const res = await api.get_admin_dashboard(pageNum);

    dispatch({type: adminDashboard,payload: res?.data});
  } catch (error) {
    dispatch({type: adminDashboard,payload: error?.response?.data || error});

    authorizedUser(error?.response?.data);
  }
};